import type { FC } from "react";
import clsx from "clsx";

import { i18n } from "@/localization";

/*
 * Both documents are long enough that the loaded panel always hits max-h-full, so the
 * fallback reserves that height too and the overlay does not resize under the reader.
 */
const BAR_WIDTHS = ["w-1/3", "w-full", "w-full", "w-11/12", "w-full", "w-2/3", "w-full", "w-5/6"];

/**
 * Suspense fallback for the lazily loaded legal text. In practice it is rarely painted — the
 * trigger warms the chunk on hover and focus — so it only has to cover a cold keyboard
 * activation or a slow connection.
 */
export const LegalBodySkeleton: FC = () => {
	return (
		<div className="flex min-h-[60vh] flex-col gap-3" aria-busy="true">
			<span className="sr-only">{i18n("legal.loading")}</span>
			{BAR_WIDTHS.map((width, index) => (
				<div
					key={index}
					className={clsx("bg-brand-dark/10 h-3 animate-pulse rounded motion-reduce:animate-none", width)}
				/>
			))}
		</div>
	);
};
